import React from 'react';
import ReactDOM from 'react-dom';
import KedroViz from './components/container';

ReactDOM.render(<KedroViz />, document.getElementById('root'));
